import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  INotification,
  INotificationCount,
  INotificationResponseData,
  INotificationState,
} from "../@types/notifications";
import { IApiResponse } from "../@types/api-response";

const initialState: INotificationState = {
  notifications: [],
  notification: null,
  notification_counts: null,
  limit: 20,
  offset: 0,
  total: 0,
  loading: false,
  show: false,
  update: false,
};

export const notification = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotifications: (
      state,
      action: PayloadAction<IApiResponse<INotificationResponseData>>,
    ) => {
      state.notifications = action.payload.data.data.map((n) => ({
        ...n,
        seen: String(n.seen) === "true",
      }));

      state.limit = action.payload.data.limit;
      state.offset = action.payload.data.offset;
      state.total = action.payload.data.total;
    },
    setNotification: (state, action: PayloadAction<INotification>) => {
      state.notification = action.payload;
    },

    setNotificationSeen: (state, action: PayloadAction<string | number>) => {
      const id = action.payload;

      // update list item
      state.notifications = state.notifications.map((item: INotification) =>
        item.id === id ? { ...item, seen: true } : item,
      );

      // update opened notification if same ID
      if (state.notification?.id === id) {
        state.notification = { ...state.notification, seen: true };
      }
    },

    setCount: (state, action: PayloadAction<INotificationCount>) => {
      state.notification_counts = action.payload;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setShow: (state) => {
      state.show = !state.show;
    },

    setUpdate: (state) => {
      state.update = !state.update;
    },
  },
});

export const {
  setNotifications,
  setNotification,
  setCount,
  setLoading,
  setShow,
  setNotificationSeen,
  setUpdate,
} = notification.actions;

export default notification.reducer;
